import type { ServicesInsightsReport } from 'model/ServicesInsightsReport';

export type ServicesInsightsReportState = {
    loading: boolean;
    report: ServicesInsightsReport;
};

export const emptyServicesInsightsReport: ServicesInsightsReport = {
    range: { start: '', end: '' },
    totals: {
        quantity: 0,
        grossSales: 0,
        discounts: 0,
        refunds: 0,
        netSales: 0,
        allNetSales: 0
    },
    meta: {
        page: 1,
        perPage: 10,
        totalCount: 0,
        totalPages: 0
    },
    services: []
};

export const initialServicesInsightsReportState: ServicesInsightsReportState = {
    loading: false,
    report: emptyServicesInsightsReport
};
